(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("map-shadows", [], factory);
	else if(typeof exports === 'object')
		exports["map-shadows"] = factory();
	else
		root["map-shadows"] = factory();
})(self, function() {
return 